import { useQuery } from '@tanstack/react-query';
import { useApi } from '../../_shared/hooks';
import { fetchEventMembers, type EventMember } from '../event-manager-client';

export function useEventMembers(campaignId: string) {
  const { apiFetch } = useApi();

  const query = useQuery<EventMember[]>({
    queryKey: ['launcher', 'campaigns', campaignId, 'event-members'],
    queryFn: () => fetchEventMembers(apiFetch, campaignId),
    enabled: !!campaignId,
    staleTime: 0,
  });

  return {
    members: query.data ?? [],
    isLoading: query.isLoading,
    isError: query.isError,
    error: query.error,
    refetch: query.refetch,
  } as const;
}
